<div
  class="simple-scroll flex flex-col justify-start items-start full-grow-no-shrink-no-basis"
>
  @if(instructions?.length > 0) {
    <div
      class="view-details "
      [innerHTML]="instructions | sanitizeHtml"
      *ngIf="instructions?.length > 0"
    ></div>
  } @else{
    <div>
      <div class="view-details ">
        <div class="no-data">
          <i class="fal fa-info-circle k-mr-2"></i>
          <span>No instructions available</span>
        </div>
      </div>
    </div>
  }
</div>
